module.exports = __webpack_public_path__ + "static/media/6.45c34240.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/6.JPG
// module id = 476
// module chunks = 0